/* tslint:disable */

/**
 */
export class Product {
    ID_PROD?: number;
    ID_STUDY?: number;
    ID_MESH_GENERATION?: number;
    PRODNAME?: string;
    PROD_ISO?: number;
    PROD_WEIGHT?: number;
    PROD_REALWEIGHT?: number;
    PROD_VOLUME?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/product.ts